import api from '..';

export const requestScheduleActivation = async (saleId: number) => {
  const { data } = await api.post(`/core/vendas/agendar-ativacao/${saleId}`);

  return data;
};
